"use client";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import MobileMenuContainer from "./MobileMenuContainer";
import Burger from "./Burger";
import { createContext } from "react";
import { SmallLogo, Logo } from "./Logos";
import NavItems from "./NavItems";
import { loraItalic } from "../../styles/fonts";

export interface MenuContextType {
  menuOpen: boolean;
  setMenuOpen: Dispatch<SetStateAction<boolean>>;
  servicesOpen: boolean;
  setServicesOpen: Dispatch<SetStateAction<boolean>>;
  headerHeight: number;
  setHeaderHeight: Dispatch<SetStateAction<number>>;
}

export const MenuContext = createContext<MenuContextType | null>(null);

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);

  return (
    <MenuContext.Provider
      value={{
        menuOpen,
        setMenuOpen,
        servicesOpen,
        setServicesOpen,
        headerHeight,
        setHeaderHeight,
      }}
    >
      <header className="sticky top-0 z-20 bg-white flex items-center mb-8 ">
        <Logo />
        <a
          href="#content"
          tabIndex={0}
          onClick={() => setMenuOpen(false)}
          className="absolute -translate-y-[10000%] bg-white focus:outline-none focus-visible:ring
        focus-visible:ring-olive focus-visible:ring-offset-4 focus:translate-y-0 z-20"
        >
          Skip to content
        </a>
        <div
          className={`hidden group3:flex group3:flex-col group4:flex-row items-center w-full ${loraItalic.className}  text-olive text-lg group4:text-xl`}
        >
          <NavItems />
        </div>
        <Burger />
      </header>
      <MobileMenuContainer />
    </MenuContext.Provider>
  );
}
